const $ = jQuery

export default function ScrollTo () {
  scrollTo(document.querySelectorAll('.scroll-down'))
  scrollTo(document.querySelectorAll('.mtt-header__local-menu-link a'))
  scrollTo(document.querySelectorAll('a[href*="#"]'))
}

function scrollTo (elements) {
  if (elements.length > 0) {
    for (let i = 0; i < elements.length; i++) {
      const EL = elements[i]
      const href = EL.getAttribute('href')
      const id = href ? href.replace('#', '') : ''
      const ELEMENT = document.getElementById(id)
      if (ELEMENT) {
        EL.addEventListener('click', (e) => {
          e.preventDefault()
          Scroll(ELEMENT)
        })
      }
    }
  }
}

export function Scroll (element) {
  $('html, body').animate({
    scrollTop: $(element).offset().top - getHeaderHeight()
  }, 800)
}

function getHeaderHeight () {
  let height = 0
  const HEADER = document.getElementById('main_header')
  HEADER && (height += HEADER.getBoundingClientRect().height)
  const ADMIN_BAR = document.getElementById('wpadminbar')
  ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
  return height
}
